// extracted by mini-css-extract-plugin
export default {"header":"index_header__-y2s3","menus":"index_menus__jd-gp","logo":"index_logo__YTAfE"};